import { Injectable, inject } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { catchError, mergeMap, map, filter } from 'rxjs/operators';

import { ChatBotsService } from './chat-bots.service';
import { ChatBotsHttpService } from './chat-bots.http.service';

import ChatBotsActions from './chat-bots.actions';
import { of } from 'rxjs';

@Injectable()
export class ChatBotsCollectionEffect {
    private readonly actions$ = inject(Actions);
    private readonly chatBotsHttpService = inject(ChatBotsHttpService);
    private readonly chatBotsService = inject(ChatBotsService);

    public readonly loadChatBotsRequest$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ChatBotsActions.loadCollectionRequest),
            filter(({ messenger }) => Boolean(messenger)),
            mergeMap(({ messenger }) =>
                this.chatBotsHttpService.getMessengerBots(messenger).pipe(
                    map((chatBots) => {
                        return ChatBotsActions.loadCollectionSuccess({
                            messenger,
                            chatBots: this.chatBotsService.normalizeChatBots(messenger, chatBots),
                        });
                    }),
                    catchError((error) => of(ChatBotsActions.loadCollectionFailure({ messenger, error })))
                )
            )
        )
    );
}
